import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { ImageConverterPipe } from '../../pipes/image-converter.pipe'; 
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [ImageConverterPipe, CommonModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
   currentYear: number = new Date().getFullYear();

}
